module.exports = __webpack_public_path__ + "static/media/001-cloud.5d419824.svg";